import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function LoginPage() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error("Credenciales inválidas");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-24">
      <h1 className="font-serif text-4xl text-[color:var(--brand-primary)] font-light">Admin</h1>
      <p className="text-sm text-[color:var(--brand-neutral)] mt-2">Acceso exclusivo Mimes Gourmet.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <Input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <Input data-testid="login-password" type="password" placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-[color:var(--brand-primary)] hover:bg-black text-white rounded-md py-6">
          {busy ? "Entrando…" : "Entrar"}
        </Button>
      </form>
    </div>
  );
}
